import { atom } from 'jotai';

export enum TABLE_MODES {
  drilldown = 'drilldown',
  filter = 'filter',
  compare = 'compare',
}

const unitAtom = atom('#');
const heightAtom = atom('s');
const modeAtom = atom(TABLE_MODES.drilldown);
const exploreViewAtom = atom({
  show: false,
  dimension: null,
});

// local metrics
const tableMetricsAtom: any = atom({ metrics: [], orderBy: null });

export { unitAtom, heightAtom, modeAtom, tableMetricsAtom, exploreViewAtom };
